import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthProvider";

const LoginForm = () => {
  const { login } = useAuth();
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const validatePassword = async () => {
    try {
      const response = await fetch(
        `https://psc.squashforlife.com:9443/api/password/${password}`
      );
      const match = await response.json();
      console.log(match);
      if (match) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valid = await validatePassword();
    if (valid) {
      console.log("Login successful");
      login("dummyToken");
      navigate("/update");
    }
  };

  return (
    <div>
      <div className="flex flex-row justify-center items-center pt-2">
        <input
          className="text-center border border-gray-400 rounded"
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        ></input>
      </div>
      <div className="flex flex-row justify-center items-center">
        <br></br>
        <button
          disabled={password === ""}
          className="mt-2 mx-2 px-2 py-1 text-black bg-gray-200 rounded hover:bg-gray-300 border border-gray-400"
          type="submit"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default LoginForm;
